import React from "react";
import { ThemeProps } from '../../genericComponents/globalStyles';
import { Button } from '../../genericComponents';
import styled from "styled-components";
import { Dropdown } from 'semantic-ui-react';


const NewsHeader = ({
    audiences,
    categories,
    mediaTypes,
    onClearFilterClick,
    selectedMediaType,
    selectedAudience,
    selectedCategory,
    onDropdownChange,
    onSearchChange,
    onSearchSubmit,
    searchText
}) => {

    return (
        <FilterContainer>
            <FilterContent>
                <SearchContainer>
                    <SearchTitle>Search for Content </SearchTitle>
                    <InputContainer>
                        <SearchInput onChange={onSearchChange} value={searchText} type="text" />
                        <SearchButton onClick={onSearchSubmit}> Search </SearchButton>
                    </InputContainer>
                </SearchContainer>
                <DividerContainer>
                    <VerticalDivider />
                    <ClearFiltersButton onClick={onClearFilterClick}>
                Clear Filters
            </ClearFiltersButton>
                    <DividerLabel />
                    <VerticalDivider />
                </DividerContainer>
                <CategoriesContainer>
                    <SubCategoriesContainer>
                        <SearchTitle>Browse Filters</SearchTitle>
                        <CategoriesRow>
                            <CategoryButton> Categories </CategoryButton>

                            <CustomDropdown
                                placeholder="Categories"
                                id="category"
                                fluid
                                search
                                selection
                                // multiple
                                options={[{ text: "-- All Categories --", value: -1 }, ...categories]}
                                onChange={onDropdownChange}
                                value={selectedCategory}
                            />

                        </CategoriesRow>
                        <DividerLabel height={'0'} />
                        <CategoriesRow>
                            <CategoryButton> Audiences </CategoryButton>
                            <CustomDropdown
                                placeholder="Audiences"
                                id="audience"
                                fluid
                                search
                                selection
                                options={[{ text: "-- All Audiences --", value: -1 }, ...audiences]}
                                onChange={onDropdownChange}
                                value={selectedAudience}
                            />


                        </CategoriesRow>
                        <DividerLabel height={'0'} />
                        <CategoriesRow>
                            <CategoryButton> Media Types </CategoryButton>
                            <CustomDropdown
                                placeholder="Media Types"
                                id="mediaType"
                                fluid
                                search
                                selection
                                options={[{ text: "-- All Media Types --", value: -1 }, ...mediaTypes]}
                                onChange={onDropdownChange}
                                value={selectedMediaType}
                            />
                        </CategoriesRow>
                    </SubCategoriesContainer>
                </CategoriesContainer>
            </FilterContent>
            
        </FilterContainer>
    )
}

export default NewsHeader;

const ClearFiltersButton = styled(Button)`
  background-color: ${ThemeProps.color.gabaYellow};
  color: ${ThemeProps.color.darkBlue};
  margin-top: 40px;
`;

const CustomDropdown = styled(Dropdown)`
  height: 48px;
  border: none;
  outline: none;
  padding-left: 15px;
  width:300px;
  width: 100%;
`;

const InputContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  max-width: 420px;
  min-width: 320px;
  @media (max-width: 720px) {
    width: 100%;
  }
`;
const CategoryButton = styled.div`
  background: ${ThemeProps.color.gabaYellow};
  border-radius: 6px 0px 0px 6px;
  margin-right:3px;
  height: 48px;
  width: 170px;
  color: ${ThemeProps.color.darkBlue};
  font-size: 16px;
  font-weight: 500;  
  text-align: center;
  display:flex;
  align-items: center;
  justify-content: center;
`;


const FilterContent = styled.div`
background-color:${ThemeProps.color.darkBlue};
width: 100%;
display: flex;
max-width: 1200px;
@media (max-width: 720px) {
  flex-direction: column;
}

`
const FilterContainer = styled.div`
  background: ${ThemeProps.color.darkBlue};
  padding-top: 50px;
  padding-bottom: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
`


const SearchContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 25px 16px;
  @media (max-width: 720px) {
    align-items: center;
  }
`;

const SearchTitle = styled.div`
  font-size: 1.8em;
  font-weight: bold;
  margin-bottom: 42px;
  color:${ThemeProps.color.white};
  display:block;
`;

const SearchInput = styled.input`
  height: 48px;
  border: none;
  outline: none;
  padding-left: 15px;
  border-radius: 5px 0 0 5px;
  width: 100%;
`;

const SearchButton = styled.button`
  background: ${ThemeProps.color.gabaYellow};
  border-radius: 0px 6px 6px 0px;
  height: 48px;
  width: 130px;
  color: ${ThemeProps.color.darkBlue};
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.1px;
  line-height: 24px;
  text-align: center;
  border: none;
  outline: none;
`;

const DividerContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  @media (max-width: 720px) {
    display: none;
  }
`;
const VerticalDivider = styled.div`
  border: 1.5px solid ${ThemeProps.color.white};
  height: 50px;
  width: 1px;
  background-color: ${ThemeProps.color.white};
  margin-left: 50%;
`;
const DividerLabel = styled.h3`
  color: ${ThemeProps.color.white};
  font-size: 16px;
  font-weight: bold;
  height: ${p => p.height || "32"}px;
  letter-spacing: -0.07px;
  line-height: ${p => p.height || "32"}px;
  width: 40px;
  margin-left: 22%;
`;

const CategoriesContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  flex:1;
  padding: 0 16px;
  @media (max-width: 720px) {
    align-items: center;
    margin-top: 10px;
  }
`;

const SubCategoriesContainer = styled.div`
  @media (max-width: 720px) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;
const CategoriesRow = styled.div`
  display: flex;
  flex-direction: row;
  width:100%;

`;